import valuationProxy from '../../../proxies/tools/valuation/Valuation';
import ServiceBase from '../../ServiceBase';

class ValuationService extends ServiceBase {
  getValuation(params) {
    return this.applyMemoryCache('Tool.valuation', params)(() =>
      valuationProxy.getValuationTool(params),
    );
  }
}

const valuationService = new ValuationService();
export default valuationService;
